import BaseAccountController from '../../lib/controllers/BaseAccountController';
import queryParameterParser from '../../lib/helpers/queryStringParser';

declare var LtFramework: lt.Static;

export default class TransactionDetailsController extends BaseAccountController {
	public static $inject: string[] = ['$scope', '$window', 'TransactionResource', 'UserResource'];

	public generalError: string;
	public generalMessage: string;
	public transaction: MyAccountApi.ITransaction;
	public subTotal: number;
	public user: MyAccountApi.IUser;

	private readonly $window: ng.IWindowService;
	private readonly Transaction: MyAccountApi.ITransactionResource;
	private readonly User: MyAccountApi.IUserResource;

	constructor($scope: ng.IScope, $window: ng.IWindowService, TransactionResource: MyAccountApi.ITransactionResource, UserResource: MyAccountApi.IUserResource) {
		super($scope);

		this.$window = $window;
		this.Transaction = TransactionResource;
		this.User = UserResource;
	}

	public print(): void {
		this.$window.print();
	}
	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		const memberId = queryParameterParser.getParameterByName(this.$window, 'memberId');
		const tranId = queryParameterParser.getParameterByName(this.$window, 'tranId');
		const partyId = queryParameterParser.getParameterByName(this.$window, 'partyId');
		const tranSource = queryParameterParser.getParameterByName(this.$window, 'tranSource');

		const params = {
			memberId,
			tranId,
			partyId,
			tranSource
		};

		if (!tranId || !memberId || !partyId || !tranSource) {
			this.generalError = 'Missing required parameters for transaction';
			return;
		}

		this.transaction = this.Transaction.get(params, (transaction: MyAccountApi.ITransaction) => {
			this.subTotal = parseFloat(transaction.subTotal || '0')
				|| ( parseFloat(transaction.tranAmount || '0')
					- parseFloat(transaction.shippingCost || '0')
					- parseFloat(transaction.taxTotal || '0')
					+ parseFloat(transaction.discount || '0')
				);
		}, () => {
			this.generalError = 'Server error while loading details for transaction: ' + tranId;
		});

		this.user = this.User.get();
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}
}
